import { useCallback } from "react";

import { useAimoParkingClient } from "hooks/aimoParking/useAimoParkingClient";
import { useSwr } from "hooks/aimoParking/useSwr";
import { AIMO_PARKING_PAGINATION_DEFAULT_SIZE } from "pages/AimoParking/constants/pagination";
import { formatQueryParams } from "utils/stringUtils";

export const useFindAllSystemNotification = ({
  keyword,
  order,
  orderBy,
  pageIndex,
  pageSize = AIMO_PARKING_PAGINATION_DEFAULT_SIZE,
}: {
  pageIndex?: number;
  orderBy?: string;
  order?: string;
  keyword?: string;
  pageSize?: number;
}) => {
  const { data, error } = useSwr<AimoParkingSystemNotificationsResponse>(
    `/system-notification?${formatQueryParams({
      keyword,
      pageSize,
      pageIndex,
      orderBy,
      order,
    })}`
  );

  return {
    data: data?.data,
    error,
    pageInfo: data?.pagination && {
      hasMore: data.pagination.hasMore,
      pageIndex: data.pagination.pageIndex,
      totalPages: data.pagination.totalPages,
      totalItems: data.pagination.totalItems,
    },
  };
};

export const useFindSystemNotificationById = (id: string) => {
  const { data, error } = useSwr<AimoParkingSystemNotification>(`/system-notification/${id}`);

  return { data, error };
};

export const useCreateSystemNotification = () => {
  const client = useAimoParkingClient();

  const create = useCallback(
    async (data: AimoParkingSystemNotificationParameter) => {
      return await client.execute({
        method: "POST",
        url: "/system-notification",
        data,
      });
    },
    [client]
  );

  return { create };
};
